import { makeStyles, Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  mainDrawer: {
    backgroundColor: theme.palette.background.paper,
    width: 450,
    "& .MuiTab-root": { minWidth: "140px" },
    "& .MuiTabs-indicator": { backgroundColor: "#0B3C5D !important" },
  },
  DrawerTabs: {
    "& .MuiTabs-indicator": { display: "none" },
    "& .Mui-selected": {
      color: "#282C33",
      "& .MuiTab-wrapper": {
        backgroundColor: "#FFFFFF",
        width: "auto",
        color: "black",
        paddingLeft: "20px",
        paddingTop: "5px",
        paddingBottom: "5px",
        paddingRight: "17px",
        borderRadius: "5px",
        boxShadow: "0px 1px 1px #2929293D",
      },
    },
  },
  drawerDetails: {
    "& .topContainer": {
      border: "1px solid #D5DCE1",
      padding: "10px",
      marginBottom: "20px",
      marginTop: "20px",
    },
    "& .heading": {
      fontWeight: "bold",
      fontSize: "15px",
      marginBottom: "-5px",
      marginTop: " 10px",
      marginLeft: "-4px",
    },
    "& .headingHistory": {
      fontWeight: "bold",
      fontSize: "15px",
      marginBottom: "-5px",
      marginTop: " 10px",
      marginLeft: "-4px",
    },
    "& .headingHistoryTrail": {
      marginLeft: "0",
    },
    "& .subHeading": { fontSize: "12px" },
    "& .subHeadingDetails": {
      fontSize: "12px",
      fontWeight: "bold",
      wordWrap: "break-word",
    },
    "& .itemRow": { margin: "5px 0px 5px 0px" },
    "& .topContainerTrail": {
      padding: "10px",
      marginBottom: "10px",
      marginTop: "10px",
    },
    "& .topContainerTrailLastDiv": {
      padding: "10px",
      marginBottom: "-20px",
      marginTop: "10px",
    },
    "& .itemRowTrail": {
      margin: "5px 0px 5px 0px",
    },
  },

  customButton: {
    "& .MuiButton-iconSizeSmall": {
      marginRight: "0",
    },
    "& .MuiBox-root": {
      marginRight: "8px",
    },
  },

  menu: {
    left: "0",
    "& .MuiPopover-paper": {
      width: "max-content",
    },
  },
  multiselectConfigFileCompression: {
    position: "relative",
    paddingLeft: "4px",
    "& .searchWrapper": {
      border: "none",
      maxHeight: "35px",
      overflow: "auto",
    },
    "& ::placeholder": {
      color: "#bcbcbc",
    },
  },
  /** Full-width gate pass row: no fixed max-height on multiselect (avoids inner scrollbar). */
  multiselectConfigGatePassFullRow: {
    position: "relative",
    paddingLeft: "4px",
    "& .searchWrapper": {
      border: "none",
      maxHeight: "none",
      overflow: "visible",
      minHeight: "40px",
    },
    "& ::placeholder": {
      color: "#bcbcbc",
    },
  },
  gatePassPrintDialogPaper: {
    overflow: "visible",
  },
  gatePassPrintDialogContent: {
    overflow: "visible",
  },
  gatePassPrintDialogForm: {
    overflow: "visible",
    "& .MuiGrid-container": {
      overflow: "visible",
    },
    "& .MuiGrid-item": {
      overflow: "visible",
    },
  },
  gatePassChassisField: {
    position: "relative",
    overflow: "visible",
    zIndex: 3,
  },
  gatePassChassisLabel: {
    display: "block",
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.54)",
    marginBottom: "6px",
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
  },
  gatePassChassisMultiselectWrapper: {
    position: "relative",
    "& .multiSelectContainer": {
      position: "relative",
      width: "100%",
    },
    "& .searchWrapper": {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      alignContent: "flex-start",
      border: "1px solid rgba(0, 0, 0, 0.23)",
      borderRadius: 4,
      minHeight: 40,
      maxHeight: 120,
      overflowY: "auto",
      overflowX: "hidden",
      padding: "6px 8px",
      boxSizing: "border-box",
    },
    "& .chip": {
      display: "inline-flex",
      alignItems: "center",
      margin: "2px 4px 2px 0",
      maxWidth: "100%",
      whiteSpace: "normal",
      wordBreak: "break-word",
      fontSize: "12px",
      lineHeight: 1.4,
    },
    "& .searchBox": {
      flex: "1 0 120px",
      minWidth: 120,
      margin: "2px 0",
      fontSize: "14px",
    },
    "& .optionListContainer": {
      position: "absolute",
      top: "calc(100% + 4px)",
      left: 0,
      right: 0,
      zIndex: theme.zIndex.modal + 10,
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      borderRadius: 4,
      maxHeight: 240,
      overflowY: "auto",
      boxShadow: theme.shadows[3],
    },
    "& .optionContainer": {
      fontSize: "14px",
      lineHeight: 1.4,
      padding: "8px 10px",
    },
    "& .optionListContainer .optionContainer:first-of-type": {
      fontSize: "14px",
      fontWeight: 600,
      padding: "8px 10px",
      borderBottom: "1px solid #e0e0e0",
      backgroundColor: "#fafafa",
    },
    "& ::placeholder": {
      color: "#bcbcbc",
    },
  },
  invoiceClimaxDialogPaper: {
    minHeight: "80vh",
    maxHeight: "90vh",
  },
  invoiceClimaxDialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: theme.spacing(1),
  },
  invoiceClimaxIframe: {
    width: "100%",
    height: "75vh",
    border: "none",
  },
}));
